/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { getRewardsCatalogByOrganization, getRewards } from 'app/state/modules/rewards'
import { getPlan } from 'app/state/modules/content'

// Utils
import analytics from 'app/views/utils/analytics'
import GiftCard from './GiftCard'
import GiftCrypto from './GiftCrypto';
import GiftGoods from './GiftGoods';
import { RewardOption } from './style'
import Loader from 'app/views/components/Loader'
import Icon from 'app/views/components/Icon'
import * as moment from 'moment'

const Rewards = (props) => {
  const organizationUuid = props.match.params.organization_uuid
  const [currentReward, setCurrentReward] = useState(-1);
  useEffect(() => {
    props.getRewardsCatalogByOrganization(organizationUuid)
    props.getRewards()
    props.getPlan()
  }, [])
  if (props.loadingCatalogByOrganization || props.loading || props.loadingPlan) {
    return <Loader visible />
  }
  let disclaimers = []
  if (props.catalogByOrganizationId[props.match.params.organization_uuid].giftCard) {
    disclaimers = props.catalogByOrganizationId[props.match.params.organization_uuid].giftCard.reduce((prev, curr, index) => {
      if (curr.giftCard.metadata.brandRequirements.alwaysShowDisclaimer) {
        prev.push({
          text: curr.giftCard.metadata.brandRequirements.disclaimer,
          id: index
        })
      }
      return prev
    }, [])
  }
  const { completed = true } = props;
  const { rewardsEnabled, incompleteLessonUuids } = props.rewardsByOrganization[organizationUuid] || { rewardsEnabled: false }
  const rewardsReadyToClaim = (incompleteLessonUuids || []).length === 0
  const lessons = props.plan[organizationUuid].reduce((prev, plan) => {
    plan.groups.forEach((group) => {
      group.content.forEach((content) => {
        if (!prev.contentUuids[content.uuid]) {
          prev.contentUuids[content.uuid] = true
          prev.content.push({ ...content, endDate: group.end_date })
        }
      })
    })
    return prev
  }, {
    contentUuids: {},
    content: []
  })
  const rewards = [
    {
      id: 'giftCard',
      imgSrc: "/static/images/rewards/gift.png",
      desc: "$20 Gift Card",
      class: "gift",
      component: GiftCard
    },
    {
      id: 'crypto',
      imgSrc: "/static/images/rewards/bitcoin.png",
      desc: "Crypto",
      class: "crypto",
      component: GiftCrypto
    },
    // {
    //   id: 'shirt',
    //   imgSrc: "/static/images/rewards/t-shirt.png",
    //   desc: "T-Shirt",
    //   class: "tshirt",
    //   component: GiftGoods
    // },
    // {
    //   id: 'mug',
    //   imgSrc: "/static/images/rewards/mugs.png",
    //   desc: "Mug",
    //   class: "mug",
    //   component: GiftGoods
    // },
    // {
    //   id: 'phoneCase',
    //   imgSrc: "/static/images/rewards/phone-cases.png",
    //   desc: "Phone Case",
    //   class: "phone",
    //   component: GiftGoods
    // }
  ];

  const CurrentComponent = currentReward !== -1 ? rewards.find((i) => i.id === currentReward) : null;

  const rewardClicked = (id) => {
    if (!rewardsReadyToClaim) {
      return;
    }
    currentReward === id ? setCurrentReward(-1) : setCurrentReward(id);
  }

  const renderRewardTypes = (reward) => {
    if (reward.id === 'giftCard') {
      return `Gift Card (${parseFloat(props.catalogByOrganizationId[organizationUuid].giftCard[0].giftCard.amount.amount).toFixed(0)} ${props.catalogByOrganizationId[organizationUuid].giftCard[0].giftCard.amount.currency})`
    }
    if (reward.id == 'crypto') {
      return `Crypto (${parseFloat(props.catalogByOrganizationId[organizationUuid].crypto[0].crypto.currencyValue.amount).toFixed(0)} ${props.catalogByOrganizationId[organizationUuid].crypto[0].crypto.currencyValue.currency})`
    }
  }

  const { claimedReward } = props.rewardsByOrganization[props.match.params.organization_uuid] || {}
  return (
    <div className="">
      <div className="uk-flex uk-flex-left uk-flex-middle uk-padding">
        <button onClick={() => props.history.replace('/')} className="uk-button uk-button-small uk-button-secondary uk-flex uk-flex-middle uk-flex-center">
          <i className="ri-arrow-left-s-line uk-margin-small-right" name="arrow-left-s"></i>
          See Full Plan
        </button>
      </div>
      <div className="uk-container">
        {!claimedReward && (
          <RewardOption className={`${completed ? "complete" : ""}`}>
            <p className="uk-text-emphasis uk-text-center uk-text-regular">Select a Reward</p>
            <div className="reward-options_container">
              {rewards.filter((item) => Boolean(props.catalogByOrganizationId[organizationUuid][item.id])).map(reward => (
                <div
                  className={`reward-option ${currentReward === reward.id ? "selected" : ""}`}
                  key={reward.id}
                  onClick={() => rewardClicked(reward.id)}
                >
                  <div className="reward-option-img">
                    <img src={reward.imgSrc} className={reward.class} alt={reward.desc} width="100%" />
                  </div>
                  <p>
                    {renderRewardTypes(reward)}
                  </p>
                </div>
              ))}
            </div>
            {(CurrentComponent && !claimedReward) && <CurrentComponent.component type={CurrentComponent.desc} />}
          </RewardOption>
        )}
        {claimedReward && <p className="uk-text-center">You already claimed a reward.</p>}
        {!rewardsReadyToClaim && <div className="uk-margin-auto" style={{ width: 1000 }}>
          <div className="uk-flex uk-flex-column">
            <p className="uk-margin-remove uk-text-emphasis">Lesson Plan</p>
            <small className="uk-text-italic">Finish the following lessons to earn your reward!</small>
            <div className="uk-grid-small" uk-grid="">
              {lessons.content.map((content) => {
                const {
                  has_test: hasTest,
                  must_pass_coding_exercise: mustPassCodingExercise,
                  completed_at: completedAt,
                  passed_at: passedAt,
                  endDate,
                } = content
                const completed = (hasTest && mustPassCodingExercise ? (passedAt) : (completedAt || passedAt))
                return (
                  <div className="uk-flex uk-flex-row uk-flex-center uk-flex-middle uk-width-1-3" key={content.uuid}>
                    <div className="uk-padding-small uk-flex uk-flex-center uk-flex-middle uk-width-1-5">
                      <Icon name={completed ? 'checkbox-circle' : 'checkbox-blank-circle'} ratio={1.2} className={completed ? 'uk-text-primary' : 'uk-text-muted'} />
                    </div>
                    <div className="uk-padding-small uk-flex uk-flex-column uk-width-4-5">
                      <p className="uk-margin-remove uk-text-emphasis uk-width-1-1">{content.title}</p>
                      <small className="uk-text-small uk-text-italic">
                        {completed ? `Completed on: ${moment(completed).format('MMMM DD, YYYY')}` : (
                          endDate ? `Complete by: ${moment(endDate).format('MMMM DD, YYYY')}` : 'No time limit'
                        )}
                      </small>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>}
        {currentReward === 'giftCard' && (
          <div className="uk-text-small uk-text-meta">
            <hr />
            <p>The merchants represented are not sponsors of the rewards or otherwise affiliated with HackEDU. The logos and other identifying marks attached are trademarks of and owned by each represented company and/or its affiliates. Please visit each company's website for additional terms and conditions.</p>
            {disclaimers.map((disclaimer) => {
              return (
                <React.Fragment key={disclaimer.id}>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{ __html: disclaimer.text }}
                  />
                </React.Fragment>
              )
            })}
          </div>
        )}
      </div>
      <div style={{ height: 200 }} />
    </div>
  )
}

const mapStateToProps = ({ rewards, content }) => ({
  rewardsByOrganization: rewards.rewardsByOrganization,
  catalogByOrganizationId: rewards.catalogByOrganizationId,
  loading: rewards.loading,
  loadingCatalogByOrganization: rewards.loadingCatalogByOrganization,
  plan: content.plan,
  loadingPlan: content.loadingPlan,
})

export default withRouter(connect(mapStateToProps, {
  getRewardsCatalogByOrganization,
  getRewards,
  getPlan,
})(Rewards))
